import styled from 'styled-components';
import { tokens } from 'styles/tokens';

// We are doing a named export here to maintain backwards compatibility with existing code,
// but this could be refactored to a default export at some point.
// To allow overriding the margin specificity here, we need to apply the margin outside
// of the styled component.
export const SecondaryText = styled.p`
    color: ${tokens.text.secondary};
    margin: 0;
`;

export const SecondaryTextSpan = styled.span`
    color: ${tokens.text.secondary};
    margin: 0;
`;

export const SmallSecondaryText = styled.div`
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: ${tokens.text.secondary};
`;
